import { __assign } from "tslib";
import { PaymentMethod as CashierPaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
export var PaymentBrand;
(function (PaymentBrand) {
    PaymentBrand["UNKNOWN"] = "UNKNOWN";
    PaymentBrand["VISA"] = "VISA";
    PaymentBrand["MASTERCARD"] = "MASTERCARD";
    PaymentBrand["AMEX"] = "AMEX";
    PaymentBrand["DISCOVER"] = "DISCOVER";
    PaymentBrand["JCB"] = "JCB";
    PaymentBrand["ENROUTE"] = "ENROUTE";
    PaymentBrand["DINERS"] = "DINERS";
    PaymentBrand["SOLO"] = "SOLO";
    PaymentBrand["MAESTRO"] = "MAESTRO";
    PaymentBrand["BANCARD"] = "BANCARD";
    PaymentBrand["CARTE_BLUE"] = "CARTE_BLUE";
    PaymentBrand["ELO"] = "ELO";
    PaymentBrand["UNIONPAY"] = "UNIONPAY";
    PaymentBrand["SEPA_DIRECT_DEBIT"] = "SEPA_DIRECT_DEBIT";
    PaymentBrand["MP_OXXO"] = "MP_OXXO";
    PaymentBrand["MP_BANAMEX"] = "MP_BANAMEX";
    PaymentBrand["MP_BANCOMER"] = "MP_BANCOMER";
    PaymentBrand["MP_SERFIN"] = "MP_SERFIN";
    PaymentBrand["BOLETO"] = "BOLETO";
    PaymentBrand["BANK_TRANSFER"] = "BANK_TRANSFER";
    PaymentBrand["YANDEX"] = "YANDEX";
    PaymentBrand["MERCADO_PAGO_RECURRING"] = "MERCADO_PAGO_RECURRING";
    PaymentBrand["CREDITS_PREPAID_CARD"] = "CREDITS_PREPAID_CARD";
    PaymentBrand["REG_DOT_RU"] = "REG_DOT_RU";
    PaymentBrand["SOFORT"] = "SOFORT";
    PaymentBrand["PAYPAL"] = "PAYPAL";
})(PaymentBrand || (PaymentBrand = {}));
export var CardBrand;
(function (CardBrand) {
    CardBrand["Visa"] = "Visa";
    CardBrand["MasterCard"] = "MasterCard";
    CardBrand["AMEX"] = "AMEX";
    CardBrand["Discover"] = "Discover";
    CardBrand["JCB"] = "JCB";
    CardBrand["ENROUTE"] = "ENROUTE";
    CardBrand["Diners"] = "Diners";
    CardBrand["SOLO"] = "SOLO";
    CardBrand["MASTERO"] = "MASTERO";
    CardBrand["VISA_DELTA"] = "VISA_DELTA";
    CardBrand["BANCARD"] = "BANCARD";
    CardBrand["ELECTRON"] = "ELECTRON";
    CardBrand["MAESTR_UK"] = "MAESTR_UK";
    CardBrand["CARTE_BLUE"] = "CARTE_BLUE";
    CardBrand["ELO"] = "ELO";
    CardBrand["SBI_MAESTRO"] = "SBI_MAESTRO";
    CardBrand["UnionPay"] = "UnionPay";
})(CardBrand || (CardBrand = {}));
var PremiumPaymentMethod;
(function (PremiumPaymentMethod) {
    PremiumPaymentMethod["Sepa"] = "sepa";
})(PremiumPaymentMethod || (PremiumPaymentMethod = {}));
export var PaymentMethodsId = __assign(__assign({}, CashierPaymentMethod), PremiumPaymentMethod);
//# sourceMappingURL=types.js.map